$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick() {
	$w('#columnStrip8').show();
	waitForLoading();
}

function waitForLoading() {
	setTimeout(() => {
		$w('#columnStrip8').hide('FadeOut');
	}, 1500);
}
